module.exports = __webpack_public_path__ + "img/LI-In-Icon.8253696.png";